import * as React from 'react';
import {
  FlexLayout, GridLayout,
} from '../../../../../components';
import { Global, TemplateProps } from '../../../../../constants';
import { Status } from '../Status';
import { StatusTabPeridGridHeader } from '../headers/StatusTabPeridGridHeader';

/**
 * 화면 > 탭 담당별
 * @window w_tb_e451w
 * @category 견적현황
 */
export const StatusTabPeridTemplate: React.FC<TemplateProps<Status>> = ({
  scope,
}) => (
  <FlexLayout isVertical={true}>
    <GridLayout
      ref={scope.gridPerid}
      infinityHandler={scope.infinityPerid}
      header={StatusTabPeridGridHeader(scope)}
      rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
      data={scope.state.dataPerid}
      onRowClick={(item) => scope.onRowFocusEvent(item)}
      onRowDoubleClick={() => scope.onClickOpenResist()}
    elGrid="dataPerid"
    />
  </FlexLayout>
);
